import { render, staticRenderFns } from "./DeliveryGoodPlanShow.vue?vue&type=template&id=60acdd9c&"
import script from "./DeliveryGoodPlanShow.vue?vue&type=script&lang=js&"
export * from "./DeliveryGoodPlanShow.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryGoodPlanShow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports